<script>
	const metadataUtils = require('metadata-utils');
	const metadata = require('core/metadata');
	const discoveryService = require('services/discoveryService');
	const _ = require('underscore');
	const utilities = require('utilities');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const stringUtilities = require('utilities/stringUtilities');
	const urlUtilities = require('utilities/urlUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const RECOMMENDATION_CLICK = analyticsUtilities.events.RECOMMENDATION_CLICK;
	var BLANK_RELATED = {
		total: 0,
		count: 0,
		hits: []
	};

	function mkCaption(items, metaData) {
		var lines = [],
			labels = {};

		_.each(items, function (id) {
			var labelKey = metaData.allActiveNodesById['_' + id],
				parentId = labelKey && labelKey.parentId,
				parent = parentId ? metaData.allActiveNodesById['_' + parentId] : null,
				parentLabelName = parent ? parent.name : '',
				labelsforParent = labels[parentLabelName],
				label = labelKey ? labelKey.name : '';

			if (labelKey && parent) {
				if (parentId === 173) {
					// DOMAIN_ID
					if (!labels[label]) {
						labels[label] = [];
					}
				} else if (labelsforParent) {
					labelsforParent.unshift(label);
				} else {
					labels[parentLabelName] = [label];
				}
			}
		});

		for (var key in labels) {
			let endLine = '';
			if (labels[key].length) {
				endLine = ': ' + labels[key].join(', ');
			}
			lines.push(key + endLine);
		}

		return lines;
	}

	module.exports = {
		components: {
			'graphic-organizer-key-modal': require('components/graphic-organizer-key-modal.vue').default,
			'info-icon': require('components/svg/info-icon.vue').default,
			'article-image': require('components/article-image.vue').default
		},
		props: [
			// (required) the article from which to pull meta data
			'article',

			// (optional) used to preserve "Search Results" back button as we click related articles
			'search-query-string',

			// (optional) if provided, used to show the topics for the question set rather than the article
			// e.g. in assets/src/scripts/component/routes/article-tabs/question-sets.vue
			// this attribute would (formerly) display the question sets skills
			// <article-aside
			//    ...
			//    v-bind:question-set="article.questionSets[selectedSet]"
			//    ...
			// </article-aside>
			'question-set',

			'description',

			'pair-text',

			'is-question-set',

			'product',

			'stepread',

			'decodables'

			// TODO: 5/11/16 Remove the question-set attribute and logic? We currently just switched it off per WEBUI-452 but we've flip flopped several times. Want to wait until sure... (Jeremy)
		],
		modelData: ['userContext', 'articleTab', 'printing'],
		data: function () {
			let textTypeById = utilities.cloneDeep(metadata.textTypeById);
			return {
				related: $.extend(true, {}, BLANK_RELATED),
				topicCaptionLines: ['(topic)'],
				skillCaptionLines: [],
				selCaptionLines: [],
				textTypeById,
				wordsmythTooltip:
					'Wordsmyth partners with ReadWorks to provide free vocabulary definitions and supports. <a href="https://www.wordsmyth.net/" target="_blank" data-outbound-link="WORDSMYTH_LOGO_TEST">Visit their site</a> to access additional vocabulary resources.'
			};
		},
		mounted() {
			var self = this;

			self.$watch('questionSet', _.bind(self.initSkillCaption, self));

			self.$watch(
				'article.uuid',
				function (uuid) {
					if (!uuid || (self.product && self.product.productType === 'AAD')) {
						self.related = $.extend(true, {}, BLANK_RELATED);
					} else {
						const productToFind = self.product || self.article;
						const { productType, subType, uuid: pid, articles, grades } = productToFind;
						let pids;

						if (productType === 'P') {
							// REVIEW - pids not used, maybe exclusions intended
							pids = Object.keys(articles).join();
						}

						let n = 3;
						let g;
						let exclusions;
						let book;

						const isBookStudy = productType === 'TS' && subType === 7000;
						if (isBookStudy) {
							book = productToFind.bookStudy.book.id;
							g = grades;
							n = 2;
							exclusions = [pid];
						} else {
							const { gradeIds, gradeDict } = metadata.gradeSelectionsWithProducts.reduce(
								(acc, { id }, index) => {
									acc.gradeIds.push(id);
									acc.gradeDict[id] = index;

									return acc;
								},
								{ gradeIds: [], gradeDict: {} }
							);

							g = grades.reduce((acc, grade, index) => {
								acc.push(grade);
								const gradeIndex = gradeDict[grade];

								if (index === 0 && gradeIndex > 0) {
									acc.unshift(gradeIds[gradeIndex - 1]);
								}

								if (index === grades.length - 1) {
									acc.push(...gradeIds.slice(gradeIndex + 1, gradeIndex + 3));
								}

								return acc;
							}, []);
						}

						discoveryService
							.findSimilars({
								q: pid,
								n,
								pt: productType,
								pids,
								subType: subType,
								g,
								exclusions,
								book
							})
							.then(function (results) {
								if (productType === 'P') {
									var ptHits = [];

									self.product.articleList.forEach(a => {
										if (a.status === 1) {
											ptHits.push(a);
										}
									});

									for (var i = 0; i < results.hits.length; i++) {
										if (!(results.hits[i].id in self.product.articles)) {
											ptHits.push(results.hits[i]);

											break;
										}
									}

									results.hits = ptHits;
								}

								if (results && results.hits && results.hits.length) {
									results.hits = results.hits.filter(r => r.id !== '65731ace-0fad-4fe2-870e-4eac1c1bb101');
								}

								self.related = results;
							});
					}

					self.initTopicCaption();
					self.initSkillCaption();

					if (metadata.socialEmotionalNode) {
						self.initSelCaption();
					}
				},
				{
					immediate: true
				}
			);
		},
		methods: {
			trackSimilarsClick: function (article) {
				let mainProduct = this.product || this.article;

				fireEvent(RECOMMENDATION_CLICK, {
					target: article.id || article.uuid,
					source: mainProduct.uuid,
					page: 'preview-aside'
				});
			},
			initSkillCaption: function () {
				let skills = [];

				if (this.article && this.article.skills) {
					skills = this.article.skills;
				} else if (this.product && this.product.skills) {
					skills = this.product.skills;
				}

				if (this.questionSet) {
					skills = this.questionSet.k || [];
				}

				this.skillCaptionLines = mkCaption(skills, metadata);

				// queston sets are presumed to be Comprehension if no skill given
				if (this.skillCaptionLines.length == 0 && this.questionSet) {
					this.skillCaptionLines = ['Skills & Strategies: Comprehension'];
				}
			},
			initTopicCaption: function () {
				let topics = [];

				if (this.article && this.article.topics) {
					topics = this.article.topics;
				} else if (this.product && this.product.topics) {
					topics = this.product.topics;
				}

				this.topicCaptionLines = mkCaption(topics, metadata);
			},
			initSelCaption: function () {
				let sel = [];

				if (this.article && this.article.sel) {
					sel = this.article.sel;
				} else if (this.product && this.product.sel) {
					sel = this.product.sel;
				}

				this.selCaptionLines = mkCaption(sel, metadata);
			},
			formatTime(seconds) {
				return utilities.formatTime(seconds);
			},
			printGOKey() {
				let modal = this.$refs.keyModal;
				if (modal && modal.printThis) {
					modal.printThis();
				}
			},
			getRelatedArticleUrl(article) {
				const root = urlUtilities.getProductURL(article);
				const searchQueryString = this.searchQueryString;
				const query = searchQueryString ? '?search=' + encodeURIComponent(searchQueryString) : '';

				return `${root}${query}`;
			}
		},
		computed: {
			noLexile: function () {
				let product = this.product;
				let article = this.article;

				if (product && ['AAD', 'TS'].includes(product.productType)) {
					return !product.minLexile && !product.maxLexile;
				}

				return !article.lexileCode;
			},
			anyReadWorksArticles: function () {
				let foundReadWorks = false;
				(this.article.specialCollections || []).forEach(c => {
					if (c.id === metadataUtils.READWORKS_COLLECTION_NODE_ID) {
						foundReadWorks = true;
					}
				});
				return foundReadWorks;
			},
			isAAD: function () {
				if (!this.article) {
					return false;
				}
				return this.article.productType === 'AAD';
			},
			shareTitle: function () {
				let product = this.product;
				let article = this.article;

				if (product && product.title) {
					return product.title;
				} else if (article && article.title) {
					return article.title;
				}
				return null;
			},
			hasChallengeTexts() {
				let product = this.product;
				return product && product.supplemental_texts && product.supplemental_texts.challenge;
			},
			hasSupportTexts() {
				let product = this.product;
				return product && product.supplemental_texts && product.supplemental_texts.support;
			},
			supplementalCopy() {
				let hasChallengeTexts = this.hasChallengeTexts;
				let hasSupportTexts = this.hasSupportTexts;
				let copy = '';

				if (hasChallengeTexts && hasSupportTexts) {
					copy =
						"This set provides both challenge and boost articles to help you differentiate for your students. Students who are interested in the topic read and comprehend at a higher level. So match challenge articles with your students' interests.";
				} else if (hasChallengeTexts) {
					copy =
						"This set provides challenge articles to help you differentiate for your students. Students who are interested in the topic read and comprehend at a higher level. So match challenge articles with your students' interests.";
				} else if (hasSupportTexts) {
					copy =
						'This set provides boost articles to help you differentiate for your students. Boost articles allow students of all reading levels to participate fully in learning and sharing about the same topics their classmates are reading about.';
				}
				return copy;
			},
			standards() {
				let standards = [];
				const product = this.product || this.article;

				if (product.standards) {
					standards = Object.values(product.standards)
						.reduce((stateStandards, specificStandards) => {
							if (specificStandards && specificStandards.length) {
								return stateStandards.concat(specificStandards);
							}
							return stateStandards;
						}, [])
						.sort();
				}

				return standards;
			},
			authors() {
				if (this.stepread) {
					return this.product.authors;
				}

				return this.article.authors;
			},
			adaptedByAuthors() {
				const { authors } = this.article;

				if (!this.stepread || _.isEqual(this.product.authors, authors)) {
					return [];
				}

				return authors;
			},
			vocabularyWords() {
				const vocab = this.article.vocab;

				return vocab && vocab.support && vocab.support.word_list;
			},
			decodableTeacherEditionStats() {
				const {
					letterSoundFoci = [],
					prereqLetterSoundFoci = [],
					alignmentFundationsUnit,
					highFrequencyAndTrickWords = [],
					nonDecodableChallengeWords = [],
					decodabilityPercentage,
					decodabilityDetails,
					decodabilityPercentageForTargetSkill
				} = this.article.decodableTeacherEdition;
				const decodableLetterSounds = metadata.decodableLetterSounds;
				const printing = this.printing;
				const joinString = printing ? '\n' : ', ';

				const stats = [
					{
						stat: letterSoundFoci.length === 1 ? 'Letter-Sound Focus' : 'Letter-Sound Foci',
						value: letterSoundFoci.map(focus => decodableLetterSounds[focus] || focus).join(joinString)
					},
					{
						stat: prereqLetterSoundFoci.length === 1 ? 'Prerequisite Letter-Sound Focus' : 'Prerequisite Letter-Sound Foci',
						value: prereqLetterSoundFoci.map(focus => decodableLetterSounds[focus] || focus).join(joinString)
					},
					{
						stat: 'Fundations Alignment',
						value: Number.isInteger(alignmentFundationsUnit) ? `Unit ${alignmentFundationsUnit}` : undefined
					},
					{
						stat: 'High Frequency and Trick Words',
						value: highFrequencyAndTrickWords.join(joinString)
					},
					{
						stat: 'Non-decodable Challenge Words',
						value: nonDecodableChallengeWords.join(joinString)
					},
					{
						stat: 'Decodability Percentage',
						value: Number.isInteger(decodabilityPercentage) ? `${decodabilityPercentage}%` : undefined
					},
					{
						value: decodabilityDetails
					},
					{
						stat: 'Target Skill Word Percentage',
						value: Number.isInteger(decodabilityPercentageForTargetSkill) ? `${decodabilityPercentageForTargetSkill}%` : undefined
					},
					{
						stat: 'Note',
						value: printing
							? undefined
							: 'Use our <a href="/find-content#!q:/g:/t:/pt:/features:/contentTab:scope-and-sequence/selectedSet:topical/">Topical Scope & Sequence</a> for a year of building both knowledge and decoding skills'
					}
				].filter(stat => !!stat.value);

				return stats;
			},
			stepReads() {
				const article = this.article;
				if (article && article.sr) {
					return Object.values(article.articles)
						.sort((a, b) => a.order - b.order)
						.map((sr, index) => {
							const { lexile, lexileCode, wordCount } = sr;
							const lexileString = lexile || lexileCode || 'Lexile pending';
							const countString = stringUtilities.formatNumber(wordCount);
							const textContent = `SR${index + 1}: ${lexileString}, ${countString} words`;

							return Object.assign({}, sr, {
								textContent
							});
						});
				}
				return [];
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.article-aside {
		.share-buttons {
			margin-bottom: 1rem;
			text-align: center;
		}

		.vocab-list-container {
			display: flex;
			align-items: center;

			img {
				cursor: pointer;
				margin-bottom: 1rem;
				margin-right: 1rem;
			}
		}

		.word-detective-instructions.article-single-meta-content,
		.meaning-mapper-instructions.article-single-meta-content {
			ol {
				list-style: decimal;

				li {
					margin-bottom: 0.25rem;
				}
			}
		}

		.stat-list {
			li {
				margin-bottom: 0.5rem;
			}
		}

		.book-study-meta {
			display: flex;

			ul {
				flex: 1;
				margin-right: 1rem;
			}
		}

		.book-study-blurb {
			ul {
				list-style-type: disc;
				padding-left: 1rem;
			}
		}

		&.printing {
			.stat-list {
				display: table;
				width: 100%;
				margin-top: 3rem;
				border: 1px solid $c-black;
				border-collapse: collapse;

				li {
					display: table-row;
				}
			}

			.stat-key,
			.stat-value {
				display: table-cell;
				border: 1px solid $c-black;
				padding: 0 0.5rem 0.5rem;
			}

			.stat-key {
				width: 16rem;
			}

			.stat-value {
				white-space: pre-wrap;
				vertical-align: middle;
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.article-aside {
			.share-buttons {
				text-align: left;
			}
		}
	}
</style>
<template>
	<aside
		class="article-aside"
		:class="{ printing: printing }">
		<share-buttons
			v-if="userContext && !userContext.classCode && !printing"
			no-querystring
			:share-thumbnail="article.thumbnail || (product && product.thumbnail)"
			:share-title="shareTitle"
			:event-data="{ tag: 'preview' }"
			glyphs>
		</share-buttons>
		<section class="article-single-meta -stats">
			<p v-if="pairText && product.subType === 8001">
				The Spanish passage in this pair will build students’ background knowledge so they can better understand the English passage about a similar
				topic.
			</p>
			<div
				v-else-if="pairText"
				v-html="description"></div>
			<template
				v-if="
					articleTab !== 'word-detective-preview' && articleTab !== 'meaning-mapper-preview' && product && product.productType === 'AAD' && !decodables
				">
				<h3 class="rte margin-bottom-small"><strong>Article-A-Day Set</strong></h3>
				<div class="article-single-meta-content">
					<ul>
						<li>Grade: {{ product.grades | getGradeRangeString }}</li>
						<li v-if="noLexile">Lexiles pending</li>
						<li v-else>Lexiles: The articles in this set range from {{ product.minLexile }}L to {{ product.maxLexile }}L</li>
					</ul>
				</div>
				<template v-if="articleTab !== 'word-detective-preview' && articleTab !== 'meaning-mapper-preview' && (hasChallengeTexts || hasSupportTexts)">
					<h3 class="rte margin-bottom-small"><strong>Differentiation Articles</strong></h3>
					<div class="article-single-meta-content">{{ supplementalCopy }}</div>
				</template>
			</template>
			<template
				v-if="
					articleTab !== 'word-detective-preview' &&
					articleTab !== 'meaning-mapper-preview' &&
					((product && product.productType === 'AAD') || article.productType === 'AAD') &&
					!decodables
				">
				<h3 class="rte margin-bottom-small"><strong>Set the Purpose for Students</strong></h3>
				<div class="article-single-meta-content">
					Remind students that words are where humans store knowledge. So they will build their knowledge by reading these articles. They will also
					increase their vocabulary, improve their reading stamina, and enjoy reading every day!
				</div>
				<a
					href="/teacher-guide/article-a-day-routine.html"
					class="article-single-meta-content">
					See how to do Article-A-Day<sup><small>TM</small></sup>
				</a>
			</template>
			<template v-if="product && articleTab === 'word-detective-preview'">
				<h3 class="rte margin-bottom-small"><strong>Word Detective</strong></h3>
				<div class="article-single-meta-content">
					<ul>
						<li><b>Focus Word Part:</b> {{ product.word_detective.affix.fragments.join(', ') }}</li>
						<li><b>Definition:</b> {{ product.word_detective.affix.definition }}</li>
						<li v-if="product.word_detective.affix.teacher_tip"><b>Teacher Tips:</b> {{ product.word_detective.affix.teacher_tip }}</li>
						<li v-if="product.word_detective.teacher_word_bank">
							<b>Examples from Articles in this Set:</b> {{ product.word_detective.teacher_word_bank.join(', ') }}
						</li>
						<li>
							<outbound-link
								href="https://about.readworks.org/uploads/7/9/6/7/79679564/word_detective_teacher_guide.pdf"
								target="_blank"
								data-outbound-link="ARTICLE_ASIDE_AAD_VOCAB_WD_TG">
								Teacher Guide
							</outbound-link>
						</li>
						<li>
							<button
								class="button -link -link-standard"
								@click="printGOKey">
								Print a key
							</button>
						</li>
					</ul>
				</div>
				<div class="article-single-meta-content">
					Word Detective is a 15-minute, teacher-led investigation of word parts designed for the last day of the Article-A-Day routine. With this simple,
					fun activity, students develop deeper vocabulary understanding.
				</div>
				<!-- <div class="article-single-meta-content">For more information on Word Detectives, view our training materials: </div> -->
				<a
					href="/teacher-guide/meaning-mapper-and-word-detective.html"
					class="article-single-meta-content">
					For more information, view our training materials.
				</a>
			</template>
			<template v-if="articleTab === 'word-detective-preview'">
				<h3 class="rte margin-bottom-small"><strong>Instructions</strong></h3>
				<div class="word-detective-instructions article-single-meta-content">
					<ol>
						<li>
							<i>Set the purpose (1 min):</i> Tell students, “Exploring words and word parts will help you become master detectives who can figure out the
							meaning of any word!”
						</li>
						<li>
							<i>Introduce and explore the word part (2 min):</i> Begin to investigate the word part in the center of the map by asking students: “Have you
							seen this word part before? What are some words you have seen use it? What do you think it might mean or do?” Use the teacher word bank for
							examples of words from the Article-A-Day set that have the word part.
						</li>
						<li>
							<i>Define and model using the word part (2 min):</i> Have students put the word part definition in the center of their maps. On the first
							branch on the map, model adding the word part with a word students brainstormed in Step 2 (or a word from the teacher word bank).
						</li>
						<li>
							<i>Play with the word part! (7 min):</i> Tell students, “You will now be word detectives! Look through articles you read this week for words
							you can add this word part to. Put these words in the first bubble on a branch on your maps and then add the word part in the second bubble!”
							The most important part of this step is encouraging students to have fun by adding the word part to create real or imaginary words!
						</li>
						<li><i>Share findings (3 min):</i> Ask a few students to share words they found in their detecting and create a class map.</li>
					</ol>
				</div>
			</template>
			<template v-if="articleTab === 'meaning-mapper-preview'">
				<h3 class="rte margin-bottom-small"><strong>Meaning Mapper</strong></h3>
				<div class="article-single-meta-content">
					<ul>
						<li><b>Focus Word:</b> {{ product && product.meaning_mapper.focus_word.word }}</li>
						<li><b>Definition:</b> {{ product && product.meaning_mapper.focus_word.definition }}</li>
						<li>
							<outbound-link
								href="https://about.readworks.org/uploads/7/9/6/7/79679564/meaning_mapper_teacher_guide.pdf"
								target="_blank"
								data-outbound-link="ARTICLE_ASIDE_AAD_VOCAB_MM_TG">
								Teacher Guide
							</outbound-link>
						</li>
						<li>
							<button
								class="button -link -link-standard"
								@click="printGOKey">
								Print a key
							</button>
						</li>
					</ul>
				</div>
				<div class="article-single-meta-content">
					Meaning Mapper is a brief, teacher-led activity for helping students build connections among words each day of the Article-A-Day routine. Start
					Meaning Mapper at the beginning of the week and finish it by the end!
				</div>
				<!-- <div class="article-single-meta-content">For more information on Word Detectives, view our training materials: </div> -->
				<a
					href="/teacher-guide/meaning-mapper-and-word-detective.html"
					class="article-single-meta-content">
					For more information, view our training materials.
				</a>
			</template>
			<template v-if="articleTab === 'meaning-mapper-preview'">
				<h3 class="rte margin-bottom-small"><strong>Instructions</strong></h3>
				<div class="meaning-mapper-instructions article-single-meta-content">
					<ol>
						<li>
							<i>Monday: Introduce the purpose and the focus word:</i> Tell students, “Creating a map of words helps you discover all the ways words connect,
							making learning words easy and fun!” Have a student read aloud the focus word and have them put the definition in the center of their maps. Ask
							students: “What words does this word make you think of or remind you of? Why?” Then have them add a word to the first branch of their maps:
							“Add a word you thought of to your map and fill in the connection bubble with something you find interesting about how the two words connect!”
						</li>
						<li>
							<i>Monday-Thursday: Add words and connections from each day’s article:</i> After the Article-A-Day routine each day, students add a word from
							the article that connects to a word or words already on their maps and fill in the connection bubble.
						</li>
						<li><i>Friday: Create a class meaning map!:</i> Ask students to share words from their maps and create a class map.</li>
					</ol>
				</div>
			</template>
			<template v-if="!product || (product && !['AAD', 'TS'].includes(product.productType))">
				<h2 class="article-single-meta-title">
					Details<template v-if="pairText && !isQuestionSet">: {{ article.title }}</template>
				</h2>
				<div class="article-single-meta-content">
					<h3
						class="topics"
						v-for="topicCaption in topicCaptionLines"
						:key="topicCaption">
						{{ topicCaption }}
					</h3>
					<h3
						class="skills"
						v-for="skillCaption in skillCaptionLines"
						:key="skillCaption">
						{{ skillCaption }}
					</h3>
					<h3
						class="sel"
						v-for="selCaption in selCaptionLines"
						:key="selCaption">
						{{ selCaption }}
					</h3>
					<ul>
						<li>Grade: {{ (article.grades || product.grades) | getGradeRangeString }}</li>
						<li v-if="!article.video">Words: {{ article.wordCount | commaGrouping }}</li>
						<li v-if="product && product.productType === 'P' && article.video">Duration: {{ formatTime(article.video.duration) }}</li>
						<li v-if="noLexile">
							<template v-if="article.video"> Lexile: N/A </template>
							<template v-if="!article.video && (isAAD || anyReadWorksArticles)"> Lexile Pending </template>
							<template v-if="!article.video && !isAAD && !anyReadWorksArticles"> no Lexile </template>
						</li>
						<li v-else>Lexile: {{ (article.lexileCode || article.lexile || []).join(', ') }}</li>
						<li>{{ (textTypeById['_' + (article.textType || (product && product.textType))] || {}).name }}</li>
					</ul>
					<template v-if="vocabularyWords">
						<h3>
							Vocabulary
							<button
								class="button -link"
								v-tooltip="'The Vocabulary Widget provides in-line definitions, translations, and word forms for key Tier 2 and Tier 3 words in an article.'">
								<info-icon></info-icon>
							</button>
						</h3>
						<div class="vocab-list-container">
							<ul>
								<li
									v-for="w in vocabularyWords"
									:key="w">
									{{ w }}
								</li>
							</ul>
						</div>
					</template>
					<template v-if="stepReads.length > 0 && !stepread">
						<h3>StepReads™ (SR)</h3>
						<ul class="stepreads-list">
							<li
								v-for="sr in stepReads"
								:key="sr.textContent">
								{{ sr.textContent }}
							</li>
						</ul>
					</template>
					<template v-if="standards && standards.length">
						<h3>Standards</h3>
						<ul>
							<li
								class="standards-list"
								v-for="standard in standards"
								:key="standard">
								{{ standard }}
							</li>
						</ul>
					</template>
					<div v-if="article.productType !== 'P'">
						<template v-if="authors.length > 0">
							<h3>{{ authors.length === 1 ? 'Author' : 'Authors' }}</h3>
							<ul class="authors-list">
								<li
									v-for="a in authors"
									:key="a">
									{{ a }}
								</li>
							</ul>
						</template>
						<template v-if="adaptedByAuthors.length > 0">
							<h3>Adapted by</h3>
							<ul class="adapted-by-list">
								<li
									v-for="a in article.authors"
									:key="a">
									{{ a }}
								</li>
							</ul>
						</template>
					</div>
				</div>
			</template>
			<template v-if="decodables">
				<h3 class="font-merriweather print-hidden">Teacher Edition</h3>
				<ul class="decodable-teacher-edition-stats stat-list list-unstyled">
					<li
						v-for="stat in decodableTeacherEditionStats"
						:key="stat.stat">
						<strong class="stat-key"
							>{{ stat.stat
							}}<span
								v-if="stat.stat"
								class="print-hidden"
								>:</span
							>
						</strong>
						<span
							v-html="stat.value"
							class="stat-value"></span>
					</li>
				</ul>
			</template>
			<template v-if="product && product.productType === 'TS' && product.subType === 7000">
				<h3 class="font-merriweather print-hidden">{{ product.bookStudy.book.title }} Book Study</h3>
				<div class="article-single-meta-content book-study-meta">
					<ul>
						<li>Grade: {{ product.grades | getGradeRangeString }}</li>
						<li v-if="noLexile">Lexiles pending</li>
						<li v-else>Lexiles: The articles in this set range from {{ product.minLexile }}L to {{ product.maxLexile }}L</li>
					</ul>
					<article-image
						class="book-study-thumbnail"
						:image-url="product.img"
						:alt-text="`${product.bookStudy.book.title} Book Cover`"
						variant="contain"></article-image>
				</div>
				<h3 class="font-merriweather print-hidden">Book Studies</h3>
				<div class="article-single-meta-content book-study-blurb">
					<p>
						ReadWorks
						<outbound-link
							href="https://www.readworks.org/teacher-guide/alignments.html"
							data-outbound-link="ARTICLE_ASIDE_BOOK_STUDIES_OVERVIEW"
							>Book Studies</outbound-link
						>
						are hand-curated text sets that align with the most commonly-taught books in ELA curricula. There are three types of Book Studies:
					</p>
					<ul>
						<li>Knowledge Book Studies build deep knowledge around key content</li>
						<li>Theme Book Studies inspire thematic reflection and discussions</li>
						<li>Deeper Dive Book Studies excite students with engaging topics related to the books</li>
					</ul>
					<p>
						Each passage included in a Book Study has a text-dependent question set to support integrated reading practice. Use our
						<outbound-link
							href="https://docs.google.com/document/d/17njI9ihupkQpJ8rJ8DfnBlz_0OkoUXi3gisjcu4mMiA/edit"
							data-outbound-link="ARTICLE_ASIDE_BOOK_STUDIES_GUIDE"
							>one-page guide</outbound-link
						>
						to integrate writing and speaking into your Book Study lessons!
					</p>
				</div>
			</template>
		</section>
		<section
			class="article-single-meta"
			v-if="related.total > 0">
			<h2 class="article-single-meta-title">Related</h2>
			<div class="article-single-related-articles">
				<section
					class="related-article"
					v-for="a in related.hits"
					:key="a.title">
					<figure
						class="related-article-featured-image"
						v-if="a.img">
						<a
							v-on:click="trackSimilarsClick(a)"
							:href="getRelatedArticleUrl(a)">
							<img
								:src="a.img"
								:alt="a.imgAlt" />
						</a>
					</figure>
					<header class="related-article-header">
						<h3>
							<a
								v-on:click="trackSimilarsClick(a)"
								:href="getRelatedArticleUrl(a)"
								>{{ a.title }}</a
							>
							<div
								v-if="a.productType === 'P' && !a.hasVideo"
								class="font-small text-muted">
								Paired Text
							</div>
							<div
								v-if="a.productType === 'P' && a.hasVideo"
								class="font-small text-muted">
								Paired Video
							</div>
							<div
								v-if="a.productType === 'S'"
								class="font-small text-muted">
								Stepread
							</div>
							<div
								v-if="a.productType === 'AAD'"
								class="font-small text-muted">
								Article-A-Day
							</div>
						</h3>
						<ul>
							<li>Grade: {{ a.grades | getGradeRangeString }}</li>
							<li v-if="!['P', 'AAD', 'TS'].includes(a.productType)">Words: {{ a.wordCount | commaGrouping }}</li>
							<li v-if="a.productType === 'AAD'">{{ a.textTypeString }}</li>
						</ul>
					</header>
					<div class="related-article-summary">
						<p v-html="a.highlight || a.excerpt"></p>
					</div>
				</section>
			</div>
		</section>
		<graphic-organizer-key-modal
			ref="keyModal"
			v-if="article.meaning_mapper || article.word_detective"
			:product="article"></graphic-organizer-key-modal>
	</aside>
</template>
